import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Modal, Row, Button, Col, Form } from 'react-bootstrap'
import { handleChartFieldChange } from '../reducers/chartFormReducer'
import { handleHospitalAdmissionChartFieldChange } from '../reducers/hospitalAdmissionFormReducer'
import { handleInfectionCourseFieldChange, updatePathogen } from '../reducers/infectionCourseFormReducer'
import { handleAntibioticsUseChartFieldChange } from '../reducers/antibioticsUseFormReducer'

const DateValidationOverrideModal = (props) => {
  const {
    show,
    errorMessage,
    toggleShow,
    data,
    resetDateValidationOverrideModal
   } = props

   const [reason, changeReason] = useState('')
   const [formIsValidated, toggleFormIsValidated] = useState(false)

  const handleSaveAndFinish = (e) => {
    if (e && e.target.value === 'yes') {
      if (reason.length === 0) {
        return toggleFormIsValidated(true)
      }
      //if user clicks yes, that means data entry was correct and we will repost the data with an override flag so the backend doesn't flag it as a date validation error

      let postData = {...data.modelData, override_date: true, dateOverrideReason: reason }
      if (props.data['model'] === 'HospitalAdmission') {
        //post to hospitalAdmission with override key
        // let postData = {...data.modelData, override_date: true }
        props.submitChartHospitalAdmissionInfo(postData, null)
      } else if (props.data['model'] === 'AntibioticsUse'){
        //post to antibioticsUse with override key
        // let postData = {...data.modelData, override_date: true }
        props.handleChartFieldChange('antibioticsUseDateOverride', null)
        props.submitChartAntibioticsUse(postData, null)
      } else if (props.data['model'] === 'InfectionCourse') {
        // let postData = {...data.modelData, override_date: true }
        props.handleChartFieldChange('infectionCourseDateOverride', null)
        props.addInfectionCourse(postData)
      } else if (props.data['model'] === 'Pathogen'){
        //post to antibioticsUse with override key
        postData = {...data.modelData.props, override_date: true, dateOverrideReason: reason }
        props.handleChartFieldChange('pathogenDateOverride', null)
        props.submitChartPathogenInfo(postData, data.modelData.pathogenInfo)
      }
      //repostdata
      props.handleChartFieldChange('chartDateErrorMessage', '')
      props.handleChartFieldChange('triggerDateOverrideModal', false)
      changeReason('')
      return toggleShow()

    } else {
      //if user clicks outside of the modal or on the close button, that means data entry was a mistake and will reset the selected date that caused the error to null
      if (props.data['model'] === 'HospitalAdmission') {
        //post to hospitalAdmission with out override key and reset date value to null
        data.modelData['admissionDate'] = null
        let postData = {...data.modelData}
        props.handleHospitalAdmissionChartFieldChange('admissionDate', null)
        props.handleChartFieldChange('hospitalAdmissionDateOverride', null)
        props.submitChartHospitalAdmissionInfo(postData, null)
      } else if (props.data['model'] === 'AntibioticsUse') {
        data.modelData['cefiderocolInitiationDate'] = null
        let postData = {...data.modelData}
        props.handleAntibioticsUseChartFieldChange('cefiderocolInitiationDate', null)
        props.handleChartFieldChange('antibioticsUseDateOverride', null)
        props.submitChartAntibioticsUse(postData, null)
      } else if (props.data['model'] === 'InfectionCourse') {
        data.modelData['date_of_onset'] = null
        let postData = {...data.modelData}
        props.handleInfectionCourseFieldChange('date_of_onset', null)
        props.handleChartFieldChange('infectionCourseDateOverride', null)
        props.addInfectionCourse(postData, null)
      } else if (props.data['model'] === 'Pathogen') {
        data.modelData.pathogenInfo.pathogen[`${props.data.modelData.pathogenInfo.key}`] = null
        data.modelData.pathogenInfo.value = null
        let postData = {...data.modelData.props}
        props.handleChartFieldChange('pathogenDateOverride', null)
        props.updatePathogen(data.modelData.props.primary_infection_sites, data.modelData.pathogenInfo.primaryInfectionSite, data.modelData.pathogenInfo.pathogen, data.modelData.pathogenInfo.key, null)
        props.submitChartPathogenInfo(postData, data.modelData.pathogenInfo)
      }
      props.handleChartFieldChange('chartDateErrorMessage', '')
      resetDateValidationOverrideModal(data)
      props.handleChartFieldChange('triggerDateOverrideModal', false)
      changeReason('')
      return toggleShow()
    }
  }

  return (
    <Modal show={show} onHide={handleSaveAndFinish} dialogClassName="modal-wide">
      <Modal.Header closeButton>
        Validation Error
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12}>
            <p>
              <strong>{errorMessage}</strong> 
            </p>

            <p>
              In most cases, these events do not occur in this order. Are you sure these dates are correct?
            </p>

            <p>
              If so, please enter the reason below:
            </p>

            <Form noValidate validated={formIsValidated}>
              <Form.Control 
                value={reason}
                onChange={(e) => changeReason(e.target.value)}
                as='textarea'
                rows={3}
                required
              />
              <Form.Control.Feedback type="invalid">
                If you are sure that this date is correct, please enter a reason
              </Form.Control.Feedback>
            </Form>
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <Button onClick={handleSaveAndFinish} value="yes" variant="primary">Yes</Button>
        <Button onClick={handleSaveAndFinish} value="no" variant="secondary">No</Button>
      </Modal.Footer>
    </Modal>
  )
}

const mapStateToProps = (state) => {
  return {
    incompleteCharts: state.chartsReducer.incompleteCharts,
  }
}

const mapDispatchToProps = {
  handleChartFieldChange,
  handleHospitalAdmissionChartFieldChange,
  handleAntibioticsUseChartFieldChange,
  handleInfectionCourseFieldChange,
  updatePathogen,
}


export default connect(mapStateToProps, mapDispatchToProps)(DateValidationOverrideModal)
